// Persistent banner reminding users that entries are machine-extracted candidates.
// Shown at the top of every page that displays dictionary content.

import { Link } from 'react-router-dom'

export function CandidateWarning() {
  return (
    <div className="bg-sky-50 border-b border-sky-200 px-4 py-2.5">
      <div className="max-w-5xl mx-auto flex items-start gap-3 text-sm text-sky-900">
        <span className="text-lg leading-none mt-0.5 shrink-0" aria-hidden>📖</span>
        <p>
          <strong>Entries are being reviewed and verified by native Tamang speakers.</strong>{' '}
          Vote or suggest corrections to help improve accuracy — 👍 upvote correct translations, 👎 downvote incorrect ones, or{' '}
          <strong>"Suggest Correction"</strong> on any entry.
          Learn more on the{' '}
          <Link to="/about" className="underline font-medium hover:text-sky-700">
            About page
          </Link>.
        </p>
      </div>
    </div>
  )
}
